(function() {
    'use strict';
    angular
        .module('MW.ContactManager.ContactAutocompleteFilter', [])
        .filter('ContactAutocompleteFilter', function() {
            return function(contacts, filter) {
                var matchingContacts = [];

                if(!Array.isArray(contacts)) {
                    return contacts;
                }

                if(filter.length <= 0) {
                    return contacts;
                }

                contacts.forEach(function (contact) {
                    if((contact.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0) ||
                       (contact.email.toLowerCase().indexOf(filter.toLowerCase()) >= 0) ) {
                        matchingContacts.push(contact);
                    }
                });

                return matchingContacts;
            };
        });
}());
